const wellnessMetrics = [
  {
    label: "Mental Calmness",
    rating: 5,
    image: "/assets/screen7-assets/1.webp",
  },
  {
    label: "Emotional Balance",
    rating: 5,
    image: "/assets/screen7-assets/2.webp",
  },
  {
    label: "Physical Relaxation",
    rating: 5,
    image: "/assets/screen7-assets/3.webp",
  },
  {
    label: "Energy Level",
    rating: 4,
    image: "/assets/screen7-assets/4.webp",
  },
  {
    label: "Sleep Quality",
    rating: 4,
    image: "/assets/screen7-assets/5.webp",
  },
  {
    label: "Stress Reduction",
    rating: 4,
    image: "/assets/screen7-assets/6.webp",
  },
];

function ratingStars(rating) {
  return "\u2605".repeat(rating) + "\u2606".repeat(5 - rating);
}

function WellnessProgressChart() {
  return (
    <section className="wellness-chart">
      <h2>Overall Wellness Progress</h2>
      <div className="wellness-chart__viewport">
        <svg
          viewBox="0 0 900 180"
          role="img"
          aria-label="Wellness progress from 62 to 94 percent"
        >
          <g stroke="#ddd">
            <line x1="60" x2="860" y1="30" y2="30" />
            <line x1="60" x2="860" y1="70" y2="70" />
            <line x1="60" x2="860" y1="110" y2="110" />
            <line x1="60" x2="860" y1="150" y2="150" />
          </g>
          <polyline
            fill="none"
            points="110,102 350,84 585,65 810,45"
            stroke="#0b542f"
            strokeWidth="3"
          />
          <g fill="#fff" stroke="#0b542f" strokeWidth="3">
            <circle cx="110" cy="102" r="7" />
            <circle cx="350" cy="84" r="7" />
            <circle cx="585" cy="65" r="7" />
            <circle cx="810" cy="45" r="7" />
          </g>
          <g fill="#0b542f" fontSize="16" fontWeight="700">
            <text x="93" y="90">62%</text>
            <text x="333" y="72">74%</text>
            <text x="568" y="53">84%</text>
            <text x="793" y="33">94%</text>
          </g>
          <g fill="#555" fontSize="13">
            <text x="88" y="170">Visit 1 · 20 May</text>
            <text x="320" y="170">Visit 2 · 02 Jun</text>
            <text x="555" y="170">Visit 3 · 05 Jun</text>
            <text x="778" y="170">Visit 4 · 10 Jun</text>
          </g>
        </svg>
      </div>
    </section>
  );
}

const ScreenSeven = () => {
  return (
    <section className="screen-seven" aria-labelledby="screen-seven-title">
      <aside className="screen-seven__intro left-side" aria-hidden="true">
        <div className="screen-seven__intro-title">
          <strong>Ayurvedic Wellness</strong>
          <span>Score</span>
        </div>
        <img
          className="screen-seven__intro-divider"
          src="/assets/screen4-assets/line.webp"
          alt=""
        />
        <p>Your personalized wellness overview</p>
      </aside>

      <div className="content-side full-screen">
        <div className="screen-seven__main main-content">
        <img
          className="screen-seven__leaf screen-seven__leaf--left"
          src="/assets/screen7-assets/leaf_01.webp"
          alt=""
          aria-hidden="true"
        />
        <img
          className="screen-seven__leaf screen-seven__leaf--right"
          src="/assets/screen7-assets/leaf.webp"
          alt=""
          aria-hidden="true"
        />

        <h1 id="screen-seven-title">Ayurvedic Wellness Score</h1>

        <section className="wellness-overview" aria-label="Wellness score summary">
          <div
            className="wellness-score-ring"
            role="img"
            aria-label="Overall wellness score: 94 percent, excellent"
          >
            <div>
              <span>Overall</span>
              <strong>94%</strong>
              <span>Wellness Score</span>
              <div className="wellness-score-ring__rating">
                <img
                  src="/assets/screen7-assets/Golden_Leaf.webp"
                  alt=""
                  aria-hidden="true"
                />
                <b>Excellent</b>
              </div>
            </div>
          </div>

          <div className="wellness-metrics">
            {wellnessMetrics.map((metric) => (
              <div className="wellness-metric" key={metric.label}>
                <img src={metric.image} alt="" aria-hidden="true" />
                <span>{metric.label}</span>
                <span className="wellness-metric__stars" aria-hidden="true">
                  {ratingStars(metric.rating)}
                </span>
                <b aria-label={`${metric.rating} out of 5`}>
                  {metric.rating}/5
                </b>
              </div>
            ))}
          </div>
        </section>

        <WellnessProgressChart />

        <section
          className="wellness-message-strip"
          aria-label="Consistency is the key to transformation."
        >
          <img
            className="wellness-message-strip__leaf"
            src="/assets/screen7-assets/leaf_01.webp"
            alt=""
            aria-hidden="true"
          />
          <span aria-hidden="true" />
          <strong>Consistency is the key to transformation.</strong>
          <span aria-hidden="true" />
          <img
            className="wellness-message-strip__lotus"
            src="/assets/screen7-assets/Golden_Leaf.webp"
            alt=""
            aria-hidden="true"
          />
        </section>
        </div>
      </div>
    </section>
  );
}

export default ScreenSeven;
